import React, { useState } from 'react';
import './Cazare.css';
import { useLanguage } from './LanguageContext';

function Cazare() {
  const [selectedImage, setSelectedImage] = useState(null);
  const { t } = useLanguage();

  const closeModal = () => setSelectedImage(null);

  return (
    <div className="cazare-page">
      <header 
        className="cazare-header"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url('/images/livada1.jpeg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <h1>{t('cazare_title')}</h1>
        <p>{t('cazare_subtitle')}</p>
      </header>

      <div className="cazare-content">
        
        {/* Secțiunea 1: Camere de familie */}
        <section className="cazare-section">
          <div className="text-content">
            <h2>{t('cazare_sec1_title')}</h2>
            <p>{t('cazare_sec1_text')}</p>
          </div>
          <div className="image-grid grid-3">
            <img src="/images/5.jpg" alt={t('alt_5')} className="clickable-img" onClick={() => setSelectedImage('/images/5.jpg')} />
            <img src="/images/10.jpg" alt={t('alt_10')} className="clickable-img" onClick={() => setSelectedImage('/images/10.jpg')} />
            <img src="/images/14.jpg" alt={t('alt_14')} className="clickable-img" onClick={() => setSelectedImage('/images/14.jpg')} />
            <img src="/images/9.jpg" alt={t('alt_9')} className="clickable-img" onClick={() => setSelectedImage('/images/9.jpg')} />
            <img src="/images/6.jpg" alt={t('alt_6')} className="clickable-img" onClick={() => setSelectedImage('/images/6.jpg')} />
            <img src="/images/11.jpg" alt={t('alt_11')} className="clickable-img" onClick={() => setSelectedImage('/images/11.jpg')} />
          </div>
        </section>

        {/* Secțiunea 2: Spații Comune */}
        <section className="cazare-section reverse">
          <div className="text-content">
            <h2>{t('cazare_sec2_title')}</h2>
            <p>{t('cazare_sec2_text')}</p>
          </div>
          <div className="image-grid grid-2">
            <img src="/images/29.jpg" alt={t('alt_29')} className="clickable-img" onClick={() => setSelectedImage('/images/29.jpg')} />
            <img src="/images/27.jpg" alt={t('alt_27')} className="clickable-img" onClick={() => setSelectedImage('/images/27.jpg')} />
            <img src="/images/28.jpg" alt={t('alt_28')} className="clickable-img" onClick={() => setSelectedImage('/images/28.jpg')} />
            <img src="/images/30.jpg" alt={t('alt_30')} className="clickable-img" onClick={() => setSelectedImage('/images/30.jpg')} />
          </div>
        </section>

        {/* Secțiunea 3: Exterior și Terasă */}
        <section className="cazare-section">
          <div className="text-content">
            <h2>{t('cazare_sec3_title')}</h2>
            <p>{t('cazare_sec3_text')}</p>
          </div>
          <div className="image-grid grid-2">
            <img src="/images/26.jpg" alt={t('alt_26')} className="clickable-img" onClick={() => setSelectedImage('/images/26.jpg')} />
            <img src="/images/spate2.jpeg" alt={t('alt_spate2')} className="clickable-img" onClick={() => setSelectedImage('/images/spate2.jpeg')} />
          </div>
        </section>

      </div>

      {/* ECRANUL MODAL */}
      {selectedImage && (
        <div className="image-modal" onClick={closeModal}>
          <span className="close-modal">&times;</span>
          <img src={selectedImage} alt="Mărită" className="modal-content" onClick={(e) => e.stopPropagation()} />
        </div>
      )}

    </div>
  );
}

export default Cazare;